import { Pipe, PipeTransform } from '@angular/core';
import { RegressionRate } from '../services/drop.down.service';

@Pipe({
    name: 'filterRegressionRate',
    standalone: true
})
export class FilterRegressionRatePipe implements PipeTransform {

    public transform(value: RegressionRate[], searchValue: string): RegressionRate[] {
        if (!searchValue || searchValue.length < 3) {
            return value;
        }
        const pattern = new RegExp('\\b' + searchValue.toLocaleLowerCase());
        return value.filter(rate => pattern.test(rate.rateName.toLocaleLowerCase()));
    }
}
